import { render, staticRenderFns } from "./ForgotPasswordVerification.vue?vue&type=template&id=01285d7a&scoped=true"
import script from "./ForgotPasswordVerification.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordVerification.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordVerification.vue?vue&type=style&index=0&id=01285d7a&prod&lang=scss&scoped=true"
import style1 from "./ForgotPasswordVerification.vue?vue&type=style&index=1&id=01285d7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01285d7a",
  null
  
)

export default component.exports